// extracted by mini-css-extract-plugin
module.exports = {"moveCloser":"MoveCloser_moveCloser__fvM4g"};